/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { orderBy } from 'lodash';
import { useHistory, useParams } from 'react-router-dom';
import { useMutation } from 'react-query';
import { Chip } from '@material-ui/core';
import jwt_decode from 'jwt-decode';
import formatDropdownOptions, {
  buildCompanySearchLabel,
  buildVesselDropdownLabel,
  buildVesselSearchLabel
} from '../../utils/formatDropdownOptions';
import DropdownFieldComponent from '../common/FormComponents/DropdownFieldComponent';
import InputFieldComponent from '../common/FormComponents/InputFieldComponent';
import withMasterData from '../MasterComponent';
import CrewForm from './CrewForm';
import getExpenseCategoryJSONlist from './queries/getExpenseCategoryJsonList';
import ConfirmCreate from '../Modal/ConfirmCreate';
import addPO from './queries/addPO';
import polygon from '../../images/icons/polygon.svg';
import showAlert from '../../utils/alert';
import removeEmpty from '../../utils/removeEmptyValuesFromObject';
import Loader from '../common/Loading';
import editPO from './queries/editPO';
import DateofService from './DateofService';
import getCurrencyList from '../vendor/queries/getCurrency';
import getLevelOnePurpose from './queries/getLevelOnePurpose';
import getLevelTwoPurpose from './queries/getLevelTwoPurpose';
import getVesselList from './queries/getVesselList';
import fetchCompanyList from './queries/getCompanyListByVessel';
import GetDuplicatePO from './queries/getDuplicatePO';
import saveSendPurchaseOrder from './queries/saveSendPurchaseOrder';
import sendPOQuery from './queries/sendPO';
import DuplicateSave from '../Modal/DuplicateSave';
import ConfirmDuplicateCrewLineItem from '../Modal/ConfirmDuplicateCrewLineItem';
import getVendorQuery from './queries/getVendorCategory';
import getVendorExpenseQuery from './queries/getVendorExpenseItem';
import MailModal from '../Modal/MailModal';
import formatDropdownOptionsVendor, { buildVendorSearchLabel } from '../../utils/formatDropdownOptionsVendor';
import getCompanyList from '../vendor/queries/getCompanyList';
import axios from '../../utils/axios';
import { apiurl } from '../../config/apiUrl';
import getDefaultCrew from './queries/getDefaultCrew';
import fetchExpenseItems from '../expenseItem/queries/fetchExpenseItems';
import { Button} from '@synergy-marine-group/synergy-ui';
import getVesselPoDefaultCrew from './queries/getVessePolDefaultCrew';
import checkPOBudgetType from './queries/checkPOBudgetType';
import { SYSTEM_GENERATED_CATEGORY_LIST } from './utils';

const budgetCategoryList = [
  { label: 'BUDGETED CATEGORY', value: 'BUDGETED CATEGORY' },
  { label: 'NON-BUDGETED CATEGORY', value: 'NON BUDGETED CATEGORY' },
  { label: 'PRE-DELIVERY CATEGORY (TAKEOVER)', value: 'PRE DELIVERY CATEGORY' },
  { label: 'HANDOVER CATEGORY', value: 'HANDOVER CATEGORY' },
  { label: 'DRY DOCK', value: 'DRY DOCK' }
];

const NULL_GUID = '00000000-0000-0000-0000-000000000000';

const hasDuplicateCrewLineItems = (purchaseOrderCrew, expenseCategoryId, expenseCategoryList, defaultCrewUuid) => {
  const airfareId = expenseCategoryList?.find(({ label }) => label === 'Airfare')?.expenseCategoryID;
  if (expenseCategoryId === airfareId) {
    return false;
  }
  const duplicateCrew = purchaseOrderCrew?.filter((item, index, self) => (
    index !== self.findIndex(
      (t) => t.crewId === item.crewId && t.expenseLineItemId === item.expenseLineItemId
    ) && item.crewId !== defaultCrewUuid
  ));
  return (duplicateCrew?.length || 0) > 0;
};

const getTrainingExpenseCategoryId = (expenseCategoryList) => (
  expenseCategoryList?.find(({ label }) => label === 'Training')?.expenseCategoryID
);

const isTrainingExpenseCategory = (expenseCategoryId, expenseCategoryList) => (
  expenseCategoryId === getTrainingExpenseCategoryId(expenseCategoryList)
);

const normalizeJoinedVesselGuids = (crew) => ({
  ...crew,
  // API expects null id when cleared; revision uses empty GUID string
  joinedVesselId:
    crew.joinedVesselId == null
    || crew.joinedVesselId === ''
    || crew.joinedVesselId === NULL_GUID
      ? null
      : crew.joinedVesselId,
  joinedVesselRevisionId:
    crew.joinedVesselRevisionId == null
    || crew.joinedVesselRevisionId === ''
    || crew.joinedVesselRevisionId === NULL_GUID
      ? NULL_GUID
      : crew.joinedVesselRevisionId,
  joinedVesselName: (crew.joinedVesselName && String(crew.joinedVesselName).trim()) || '',
  joinedVesselStatus: (crew.joinedVesselStatus && String(crew.joinedVesselStatus).trim()) || ''
});

const POForm = ({ dataObj, setisLoading, setisduplicateloading,
  setDraft, isDraft, mode, isFetchingPo, expenseItemList,restoredPpeCategoryDetails,setRestoredPpeCategoryDetails }) => {
  const history = useHistory();
  const { poId } = useParams();
  const [modal, setModal] = useState(false);
  const [saveModal, setSaveModal] = useState(false);
  const [formValues, setformValues] = useState(null);
  const [vendorAddress, setAddress] = useState(null);
  const [expenseitemsData, setexpenseitemsData] = useState([]);
  const [filteredVendorList, setfilteredVendorList] = useState([]);
  const [initialDataLoaded, setinitialDataLoaded] = useState(true);
  const [checkOutDataLoaded, setcheckOutDataLoaded] = useState(true);
  const [duplicateData, setduplicateData] = useState([]);
  const [openHeader, setopenHeader] = useState(true);
  const [airfareOpen, setairfareOpen] = useState(null);
  const [mailModal, setMailModal] = useState(false);
  const [editPoValues, setEditPoValues] = useState(null);
  const [disableHeader, setdisableHeader] = useState(false);
  const [mailBasicInfo, setmailBasicInfo] = useState({ to: [], cc: [], subject: 'Purchase Order is created', isCustomSubject: true });
  const [mailVendorList, setMailVendorList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [defaultCrewData, setDefaultCrewData] = useState(null);
  const [selectedDefaultCrewData, setSelectedDefaultCrewData] = useState(null);
  const [savedaccountCode, setSavedAccountCode] = useState(null);
  const [companyId, setCompanyId] = useState();
  const [createdAccountCode, setcreatedAccountCode] = useState();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingValues, setPendingValues] = useState(null);
  const [showDuplicateCrewModal, setShowDuplicateCrewModal] = useState(false);
  const duplicateCrewProceedRef = useRef(null);
  const duplicateCrewConfirmedRef = useRef(false);
  const [isCrewPage, setisCrewPage] = useState();
  const filterAndFillExpItm = (item) => {
    let flag = true;
    item.find((val) => {
      if (val.label === dataObj?.purchaseOrderCrew?.expenseLineItem && flag) {
        flag = false;
      }
    });
    return flag;
  };

  const oldVendorId = dataObj?.vendorId;
  const OldExpenseCategoryId = dataObj?.expenseCategoryId;

  const {
    isLoading: expenseCategoryLoading,
    data: expenseCategory
  } = getExpenseCategoryJSONlist();
  const filteredExpenseCategoryData = expenseCategory?.data?.filter((item) => {
    const isSystemGenerated = SYSTEM_GENERATED_CATEGORY_LIST.includes(item.categoryName);
    const isSelectedSystemGenerated = SYSTEM_GENERATED_CATEGORY_LIST.includes(dataObj?.expenseCategoryName);

    // Crew PO: show only categories where poCategory includes 0; Vessel PO: includes 1 (isPageHandler is 'crew'|'vessel' string)
    const isCrew = isCrewPage === true || isCrewPage === 'crew';
    const isVessel = isCrewPage === false || isCrewPage === 'vessel';
    const poCategoryValue = isCrew ? 0 : (isVessel ? 1 : null);
    if (poCategoryValue != null) {
      if (!item.poCategory) return false;
      const hasMatchingPoCategory = Array.isArray(item.poCategory)
        ? item.poCategory.includes(poCategoryValue)
        : item.poCategory === poCategoryValue;
      if (!hasMatchingPoCategory) return false;
    } else if (!item.poCategory) {
      return false;
    }
    // Exclude system-generated categories unless the selected one itself is system-generated
    if (isSystemGenerated && (mode === 'add' || (mode === 'edit' && !isSelectedSystemGenerated))) {
      return false;
    }
    return true;
  });
  const expenseCategoryList = formatDropdownOptions(filteredExpenseCategoryData, 'categoryName', 'expenseCategoryID');

  const validationSchema = Yup.object({
    expenseCategoryId: Yup.string().required('Please select the Category'),
    vendorId: Yup.string().required('Please select the Vendor'),
    currencyId: Yup.number().nullable().required('Please enter the Currency'),
    companyId: Yup.number()
    .typeError('Please select the Company')
    .required('Please select the Company'),    
    description: Yup.string().trim().max(250, 'Must be 250 characters or less').nullable(),
    purchaseOrderCrew: Yup.array(
      Yup.object().shape({
        ...(isCrewPage && {
          crewCode: Yup.string().required('Please add Crew').nullable(),
          firstName: Yup.string().required('Please enter a valid and unique Crew code'),
          plannedVesselId: Yup.string().when('expenseLineItemId', {
            is: (val) => {
              const ppeKitValue = expenseitemsData?.find(({ label }) => label === 'PPE KIT')?.value;
              const ppeKitExpenseCategoryID = expenseitemsData?.find(({ label }) => label === 'PPE KIT')?.expenseCategoryID;
              const ppeValue = expenseCategoryList?.find(({ label }) => label === 'PPE')?.value;
              return val === ppeKitValue && ppeKitExpenseCategoryID === ppeValue;
            },
            then: Yup.string().required('Please select the Vessel').nullable(),
            otherwise: Yup.string().nullable(), 
          }),
        }),
        ...(!isCrewPage && {
          plannedVesselId:Yup.string().required('Please select the Vessel').nullable(),
        }),
        expenseLineItemId: Yup.string().required('Please select the Expense Item'),
        ...(isCrewPage && {
        amount: Yup.number().moreThan(0, 'Please enter a more than 0 value Amount').required('Please enter a valid Amount').nullable(),
      }),
        ppeDeliveryRemarks: Yup.string().when('expenseLineItemId', {
          is: (val) => {
  const ppeKitValue = expenseitemsData?.find(({ label }) => label === 'PPE KIT')?.value;
  const ppeKitExpenseCategoryID = expenseitemsData?.find(({ label }) => label === 'PPE KIT')?.expenseCategoryID;
  const ppeValue = expenseCategoryList?.find(({ label }) => label === 'PPE')?.value;
  return val === ppeKitValue && ppeKitExpenseCategoryID === ppeValue;
},
          then: Yup.string().required('Please enter the Delivery Remarks').trim().max(250, 'Must be 250 characters or less').nullable(),
          otherwise: Yup.string().nullable(),
        }),
        ...(isCrewPage && {
        ppeCategoryDetails: Yup.array().when('expenseLineItemId', {
          is: (val) => {
    const ppeKitValue = expenseitemsData?.find(({ label }) => label === 'PPE KIT')?.value;
    const ppeKitExpenseCategoryID = expenseitemsData?.find(({ label }) => label === 'PPE KIT')?.expenseCategoryID;
    const ppeValue = expenseCategoryList?.find(({ label }) => label === 'PPE')?.value;
    return val === ppeKitValue && ppeKitExpenseCategoryID === ppeValue;
    },
          then: Yup.array(
            Yup.object().shape({
              quantity: Yup.number().moreThan(0, 'Please enter a more than 0 value Quantity').required('Please enter a valid Quantity').nullable()
            })
          ),
          otherwise: Yup.array().nullable(),
        }),
      }),
...(!isCrewPage && {
          ppeCategoryDetails: Yup.array().when('expenseLineItemId', {
            is: (val) => {
              const vesselPpeId = expenseitemsData?.find(({ label }) => label === 'Vessel PPE KIT' || label === 'PPE')?.value;
              return val === vesselPpeId;
            },
            then: Yup.array()
              .transform((value, originalValue) => {
                if (Array.isArray(originalValue)) return originalValue;
                if (originalValue != null && typeof originalValue === 'object') return [originalValue];
                return originalValue;
              })
              .min(1, 'Please add at least one PPE item')
              .required('Please add at least one PPE item'),
            otherwise: Yup.array()
              .transform((value, originalValue) => {
                if (Array.isArray(originalValue)) return originalValue;
                if (originalValue != null && typeof originalValue === 'object') return [originalValue];
                return originalValue;
              })
              .nullable(),
          }),
        }),

    
    })
    ),
    // EndSession should greater than StartSession
    EndSession: Yup.date().when('StartSession', (StartSession, schema) => {
      if (StartSession) {
        return schema.min(StartSession, 'End Session should be greater than Start Session');
      }
    }),
    dateOfService: Yup.array(
      Yup.object().shape({
        dateOfServices: Yup.string().required('Please add a Date '),
      })
    ),
  });
  const { data: companies, mutate: getCompanyByCategory } = getCompanyList();
  const baseCompanyList = formatDropdownOptions(companies?.data, 'name', 'id') || [];
  const companyList = baseCompanyList.map((item, index) => {
    const safeItem = item || {};
    const rawCompany = companies?.data?.[index];
    const companyName = rawCompany?.name || safeItem?.name || safeItem?.label || '';
    const sapCompanyCode = rawCompany?.sapCompanyCode;
    const label = sapCompanyCode ? `${companyName} (${sapCompanyCode})` : companyName;
    return {
      ...safeItem,
      label,
      name: companyName,
      searchLabel: buildCompanySearchLabel(companyName, sapCompanyCode),
      sapCompanyCode: sapCompanyCode ?? safeItem?.sapCompanyCode
    };
  });

  const { data: currencies } = getCurrencyList();

  const { mutate: checkBudgetType, isLoading: isCheckBudgetLoading } = checkPOBudgetType();

  const { mutate: addPurchaseOrder,
    isSuccess: isAddSuccess, isError: isAddError,
    reset: resetAdd, isLoading: isAddLoading } = addPO();
  const {
    mutate: sendPurchaseOrder,
    isSuccess: issendPurchaseOrderSuccess,
    isError: issendPurchaseOrderError,
    reset: resetsendPurchaseOrder,
    isLoading: issendPurchaseOrderLoading,
  } = saveSendPurchaseOrder();

  const {
    mutate: editPurchaseOrder,
    isSuccess: isEditSuccess,
    isError: isEditError,
    reset: resetEdit,
    isLoading: isEditLoading
  } = editPO();

  const { data: company, isLoading: getCompanyDataLoading } = fetchCompanyList();

  const { data: vessels, mutate: getVesselData } = getVesselList();
  const baseVesselList = formatDropdownOptions(vessels?.data, 'name', 'vesselRevisionId', 'vesselCode', true) || [];
  const vesselRawByRevisionId = new Map(
    (vessels?.data || []).map((v) => [String(v?.vesselRevisionId || '').toLowerCase(), v])
  );
  const vesselList = baseVesselList.map((item) => {
    const safeItem = item || {};
    const lookupKey = String(safeItem?.value || safeItem?.vesselRevisionId || '').toLowerCase();
    const raw = vesselRawByRevisionId.get(lookupKey)
      || (vessels?.data || []).find((v) => String(v?.id) === String(safeItem?.id))
      || {};
    const vesselName = raw?.name || safeItem?.name || '';
    const vesselCode = raw?.vesselCode || safeItem?.vesselCode || '';
    const sapVesselCompanyCode = raw?.sapVesselCompanyCode ?? safeItem?.sapVesselCompanyCode;
    const status = raw?.status ?? safeItem?.status;
    return {
      ...safeItem,
      name: vesselName,
      vesselCode,
      status,
      label: buildVesselDropdownLabel(vesselName, vesselCode, sapVesselCompanyCode, status),
      searchLabel: buildVesselSearchLabel(vesselName, vesselCode, sapVesselCompanyCode, status),
      vesselRevisionId: raw?.vesselRevisionId || safeItem?.vesselRevisionId || safeItem?.value,
      id: raw?.id ?? safeItem?.id,
      sapVesselCompanyCode
    };
  });
  const { data: purposeLevelOne, isLoading: purposeLevelOneLoading } = getLevelOnePurpose();
  const purposeLevelOneList = formatDropdownOptions(purposeLevelOne?.data, 'purposeName', 'purposeID');
  const { mutate: getLevelTwoPurposeData,
    data: purposeLevelTwo } = getLevelTwoPurpose();
  const purposeLevelTwoList = formatDropdownOptions(purposeLevelTwo?.data, 'purposeName', 'purposeID');

  const { mutate: GetDuplicatePOEx, data: duplicate } = GetDuplicatePO();

  const buildVendorDropdownLabel = (vendorCode, vendorName, sapVendorCode) => {
    const code = (vendorCode && String(vendorCode).trim()) || '';
    const name = (vendorName && String(vendorName).trim()) || '';
    const sap = (sapVendorCode != null && String(sapVendorCode).trim() !== '') ? String(sapVendorCode).trim() : '';
    if (code && name && sap) return `${code} - ${name} (${sap})`;
    if (code && name) return `${code} - ${name}`;
    if (name && sap) return `${name} (${sap})`;
    return name || code || '-';
  };

  const filterCategoryvendor = (data) => {
    const options = formatDropdownOptionsVendor(data?.data, 'vendorName', 'id', 'vendorCode') || [];
    const rawById = new Map((data?.data || []).map((v) => [v?.id, v]));
    const vendorOptions = options.map((opt) => {
      const raw = rawById.get(opt?.id) || {};
      const vendorName = raw?.vendorName || opt?.vendorName || opt?.label || '';
      const vendorCode = raw?.vendorCode || opt?.vendorCode || '';
      const sapVendorCode = raw?.sapVendorCode;
      return {
        ...opt,
        label: buildVendorDropdownLabel(vendorCode, vendorName, sapVendorCode),
        searchLabel: buildVendorSearchLabel(vendorCode, vendorName, sapVendorCode),
        sapVendorCode: sapVendorCode ?? opt?.sapVendorCode
      };
    });
    setfilteredVendorList(vendorOptions);
  }
  const {
    mutate: getvendorCategoryData
  } = useMutation(['getVendorCategory'], getVendorQuery, {
    onSuccess: filterCategoryvendor
  });
  const filterExpensiveVendor = (data) => {
    setexpenseitemsData(formatDropdownOptions(data?.data, 'expenseLineItem', 'expenseLineItemID'))
  }
  const {
    mutate: getvendorExpensiveData
  } = useMutation(['getVendorExpenseitem'], getVendorExpenseQuery, {
    onSuccess: filterExpensiveVendor
  });

  const {
    mutate: sendPOEditData,
    isLoading: sendPOEditLoading,
  } = useMutation(['sendPO'], sendPOQuery, {
    onSuccess: () => {
      history.push('/');
      showAlert('Purchase Order sent successfully', 'success');
    },
    onError: () => {
      history.push(`/po/${poId}`);
    }
  });

  if (isAddError) {
    resetAdd();
    showAlert('Something went wrong', 'error');
  }
  if (issendPurchaseOrderError) {
    resetsendPurchaseOrder();
    history.push(`/`);
  }

  if (isEditError) {
    resetEdit();
    history.push('/');
    showAlert('Given Purchase order is not active', 'error');
  }
  if (isAddSuccess) {
    setformValues(null);
    resetAdd();

    if (isDraft) {
      showAlert('Purchase Order Saved as Draft Successfully', 'success');
    } else {
      showAlert('Purchase Order Created Successfully', 'success');
    }
    history.push('/');
  }
  if (issendPurchaseOrderSuccess) {
    setformValues(null);
    resetsendPurchaseOrder();
    showAlert('Purchase Order Sent Successfully', 'success');
    history.push('/');
  }

  if (isEditSuccess) {
    setformValues(null);
    resetEdit();
    if (isDraft) {
      showAlert('Purchase Order Updated Successfully', 'success');
    history.push(`/po/${poId}`);
    }
  }
 useEffect(() => {
const raw = localStorage.getItem('isPageHandler');
if (!raw) return;
let pageType;
try {
pageType = JSON.parse(raw);
} catch (e) {
pageType = raw;
}
setisCrewPage(pageType === 'crew');
}, []);
  useEffect(() => {
    let modified = false;
    if (dataObj?.poStatus === 'Draft') {
      dataObj?.purchaseOrderCrew.forEach((item) => {
        if (item?.ppeIsModified === true) {
          modified = true;
        }
      });
    }
    if (modified) {
      showAlert('PO details are updated as per the latest Master data change. Kindly review before sending the PO', 'warning');
    }
  }, [dataObj?.poStatus]);
  
  useEffect(() => {
    if (!getCompanyDataLoading) {
      setisLoading(false);
    }
  }, [getCompanyDataLoading]);
useEffect(() => {
  dataObj?.purchaseOrderCrew.map((crew) => {
    if (crew?.invoiceStatus?.toLowerCase().includes('payment') || crew?.invoiceStatus?.toLowerCase().includes('voucher') || crew?.invoiceStatus?.toLowerCase().includes('transferred')) {
      setdisableHeader(true);
    }
  })
}, [dataObj]);
const getAccountCode = (id,values) => {
   if(!savedaccountCode){
   const crewItem = values?.purchaseOrderCrew?.[id];
   if (!crewItem) return null;
   const expenseLineItemID = crewItem?.expenseLineItemId;
   const matchedItem = expenseitemsData?.find(
     (item) => item.expenseLineItemID === expenseLineItemID
   );
   if (matchedItem?.companyExpenseAccountCodeList?.length > 0) {
    const companyMatch = matchedItem.companyExpenseAccountCodeList.find(
       (entry) =>String(entry.companyId) === String(companyId)
     );
     if (companyMatch) {
       return companyMatch.accountCodeName;
     }
   } 
   return matchedItem?.accountCode || crewItem?.accountCode;
 }
 else{
   return savedaccountCode[id].accountCode
 }
 };
  const createReqFormat = (invalidCourceData) => {
    const req = { ...formValues };
    if(isCrewPage)
      {
        req.pocategory=0
      } else{
        req.pocategory=1  
      }
    const expenseFields = expenseCategoryList.find((
      { expenseCategoryID }) => expenseCategoryID === formValues?.expenseCategoryId)?.expenseFields;
    if (expenseFields) {
      const categoryDetails = expenseFields
        .map((i) => {
          if (i.key in formValues) {
            return { ...i, value: formValues[i.key] };
          }
        })
        ?.filter((i) => i);

      if (categoryDetails.length > 0) {
        req['categoryDetails'] = categoryDetails;
      }
    }
    if(!isCrewPage)
    {
      req.purchaseOrderCrew[0].crewCode=defaultCrewData?.crewCode
      req.purchaseOrderCrew[0].crewId=defaultCrewData?.uuid

    }
    let formatedPurchaseOrderCrew = [];
    if (req?.purchaseOrderCrew?.length > 0) {
      formatedPurchaseOrderCrew = req.purchaseOrderCrew.map((element) => {
        return removeEmpty(element);
      });
    }
    req.purchaseOrderCrew = formatedPurchaseOrderCrew;

    const {
      vendorId,
      expenseCategoryId,
      currencyId,
      purchaseOrderCrew,
      isBulkOrder,
      address,
      description,
      companyId,
      poNumber,
      dateOfService,
      purposeId,
      purposeLevelId,
      budgetCategory,
      pocategory
    } = req;
    const reqObj = {
      vendorId,
      poNumber,
      expenseCategoryId,
      currencyId,
      purchaseOrderCrew: purchaseOrderCrew?.map((
        {accountCode, categoryDetails, crewId,expenseLineItemId, ppeCategoryDetails, ppeDeliveryRemarks,
          plannedVesselId, amount, purchaseOrderCrewId, crewRank, airfareStatus, plannedVesselRevisionId,
          joinedVesselId, joinedVesselRevisionId, joinedVesselName, joinedVesselStatus }
          ) => ({
        crewId,
        accountCode,
        amount,
        expenseLineItemId,
        plannedVesselId,
        purchaseOrderCrewId,
        categoryDetails,
        ppeCategoryDetails,
        ppeDeliveryRemarks,
        plannedVesselRevisionId,
        crewRank,
        airfareStatus: airfareStatus || airfareOpen,
        joinedVesselId,
        joinedVesselRevisionId,
        joinedVesselName,
        joinedVesselStatus
      }))?.map(normalizeJoinedVesselGuids),
      isBulkOrder,
      address,
      description,
      isSaveAsDraft: isDraft,
      companyId,
      dateOfService,
      purposeId,
      purposeLevelId,
      budgetCategory,
      pocategory
    };
    const duplicateCheck = (duplicate,values) => {
    let ppe= expenseCategoryList?.find(({ label }) => label === 'PPE')?.expenseCategoryID;
    let vesselPpe= expenseCategoryList?.find(({ label }) => label === 'Vessel PPE')?.expenseCategoryID;
      if (duplicate?.data?.isDuplicateExists) {
        if (selectedDefaultCrewData && selectedDefaultCrewData.crewCode) {
          const isCommonCrew = values?.purchaseOrderCrew.some(
            (crew) => crew.crewId === selectedDefaultCrewData.uuid
          )
          if(isCommonCrew && (values.expenseCategoryId === ppe)) {
            setMailModal(true);
          } else {
        setduplicateData(duplicate.data.poInfo);
        setSaveModal(true);
          }
      } 
    } else if (!duplicate?.data?.isDuplicateExists) {
        setMailModal(true);
      }
      return () => clearTimeout(timer);
    };
    const handleSendPO = async () => {
      setMailVendorList(filteredVendorList);
      setisduplicateloading(true);
      await GetDuplicatePOEx(reqObj);
      setTimeout(() => duplicateCheck(JSON.parse(localStorage.getItem('duplicatecheck')),reqObj), 500);    
};

    if (reqObj?.purchaseOrderCrew?.length > 0) {
      setEditPoValues(reqObj);
      const trainingId = expenseCategoryList?.find(({ label }) => label === 'Training')?.expenseCategoryID;
      const hasDuplicateCrew = hasDuplicateCrewLineItems(
        reqObj?.purchaseOrderCrew,
        reqObj?.expenseCategoryId,
        expenseCategoryList,
        defaultCrewData?.uuid
      );
      // check different crewId present in the purchaseOrderCrew	
      let invalidChecks = true;
      
    if (formValues?.expenseCategoryId === trainingId && invalidCourceData?.data?.isMolTraining && invalidCourceData?.data?.validationResults.some(validationResult => validationResult?.isValid === false)) {
      {invalidCourceData?.data?.validationResults?.map((item) => {
        if (item?.isValid === false) {
        let tempData = item?.expenseLineItem;
        let stringData= 'There is no Course Code available for this Line Item- '
        showAlert(stringData+tempData, 'error');
        invalidChecks = false;
        }
      })}
    }
      const sameCrew = reqObj?.purchaseOrderCrew?.filter((item, index, self) => index === self.findIndex((t) => t.crewId === item.crewId));	
      let trainingAcceptable=true;	
     if (reqObj?.expenseCategoryId === trainingId && sameCrew.length > 1 && !isBulkOrder) {	
        trainingAcceptable = false;	
      }

      const proceedWithPoSubmit = (submitReqObj) => {
        if (mode === 'add') {
          setDraft(true);
          if (!isDraft) {
            handleSendPO();
          } else if (!issendPurchaseOrderError) {
            addPurchaseOrder(submitReqObj);
          }
        } else if (!isDraft) {
          submitReqObj.purchaseOrderCrew = purchaseOrderCrew.map(({ accountCode, crewCode, firstName, lastName, categoryDetails, ppeCategoryDetails, ppeDeliveryRemarks, crewId, plannedVesselId, expenseLineItemId, airfareStatus, amount, purchaseOrderCrewId, id, plannedVesselRevisionId, joinedVesselId, joinedVesselRevisionId, joinedVesselName, joinedVesselStatus }) => ({
            crewId,
            crewCode,
            firstName,
            lastName,
            amount,
            expenseLineItemId,
            plannedVesselId,
            purchaseOrderCrewId,
            categoryDetails,
            ppeCategoryDetails,
            ppeDeliveryRemarks,
            id,
            accountCode,
            airfareStatus: airfareStatus || airfareOpen,
            plannedVesselRevisionId,
            joinedVesselId,
            joinedVesselRevisionId,
            joinedVesselName,
            joinedVesselStatus
          })).map(normalizeJoinedVesselGuids);
          editPurchaseOrder({ ...submitReqObj, id: dataObj?.id, poNumber });
          handleSendPO();
        } else {
          submitReqObj.purchaseOrderCrew = purchaseOrderCrew.map(({ accountCode, crewCode, firstName, lastName, categoryDetails, ppeCategoryDetails, ppeDeliveryRemarks, crewId, plannedVesselId, expenseLineItemId, airfareStatus, amount, purchaseOrderCrewId, id, plannedVesselRevisionId, joinedVesselId, joinedVesselRevisionId, joinedVesselName, joinedVesselStatus }) => ({
            crewId,
            crewCode,
            firstName,
            lastName,
            amount,
            expenseLineItemId,
            plannedVesselId,
            purchaseOrderCrewId,
            categoryDetails,
            ppeCategoryDetails,
            ppeDeliveryRemarks,
            id,
            accountCode,
            airfareStatus: airfareStatus || airfareOpen,
            plannedVesselRevisionId,
            joinedVesselId,
            joinedVesselRevisionId,
            joinedVesselName,
            joinedVesselStatus
          })).map(normalizeJoinedVesselGuids);
          editPurchaseOrder({ ...submitReqObj, id: dataObj?.id, poNumber });
        }
      };

      if (trainingAcceptable && invalidChecks === true) {
        if (!hasDuplicateCrew || duplicateCrewConfirmedRef.current) {
          proceedWithPoSubmit(reqObj);
        } else if (isTrainingExpenseCategory(reqObj?.expenseCategoryId, expenseCategoryList)) {
          duplicateCrewProceedRef.current = () => {
            duplicateCrewConfirmedRef.current = true;
            proceedWithPoSubmit(reqObj);
            setModal(false);
          };
          setShowDuplicateCrewModal(true);
          return;
        } else {
          showAlert('A combination of Crew Code and Expense Line Item already exists in the list', 'error');
        }
      } else if (invalidChecks === true) {
        showAlert('Different Crew Codes are not allowed for Expense Category- Training.', 'error');
      }
  } else {
    showAlert('Please add atleast one crew', 'error');
  }
    setModal(false);
    duplicateCrewConfirmedRef.current = false;
  };
  const handleBulkOrder = () => {
    setformValues((prevState) => ({ ...prevState, isBulkOrder: true }));
  };

  const handleCreate = () => {
    setformValues((prevState) => ({ ...prevState, isBulkOrder: false }));
  };

  const continueSubmitAfterDuplicateCheck = (finalValues) => {
    const crewLength = finalValues?.purchaseOrderCrew?.length || 0;

    if (!isCrewPage && crewLength > 1) {
      const accountCodes = finalValues?.purchaseOrderCrew?.map((crew) => crew?.accountCode)?.filter(Boolean) || [];
      const budgetCheckPayload = {
        companyId: finalValues?.companyId,
        vesselDetailsId: finalValues?.purchaseOrderCrew?.[0]?.plannedVesselRevisionId || '',
        poId: dataObj?.id || '',
        accountCode: accountCodes,
        poCategory: finalValues?.pocategory
      };

      checkBudgetType(budgetCheckPayload, {
        onSuccess: (response) => {
          const { poBudgetType, accountCodes: mismatchedAccountCodes } = response?.data || {};
          if (poBudgetType === 'Ok') {
            if (crewLength > 1 && mode === 'add') {
              setModal(true);
            }
            setformValues(finalValues);
          } else {
            const accountCodesList = mismatchedAccountCodes?.join(', ') || '';
            let errorMessage = '';

            if (mode === 'edit') {
              if (poBudgetType === 'Fixed') {
                errorMessage = `The PO is Fixed Budget PO, but the following account codes are of Actual Budget Types. Account Codes: ${accountCodesList}`;
              } else if (poBudgetType === 'Actual') {
                errorMessage = `The PO is Actual Budget PO, but the following account codes are of Fixed Budget Types. Account Codes: ${accountCodesList}`;
              }
            } else if (poBudgetType === 'Fixed') {
              errorMessage = `The first line-item has Fixed Budget account code. But the following account codes are of Actual Budget Types. Account Codes: ${accountCodesList}`;
            } else if (poBudgetType === 'Actual') {
              errorMessage = `The first line-item has Actual Budget account code. But the following account codes are of Fixed Budget Types. Account Codes: ${accountCodesList}`;
            }

            showAlert(errorMessage, 'error');
          }
        },
        onError: () => {
          showAlert('Failed to validate PO budget type', 'error');
        }
      });
      return;
    }

    if (crewLength > 1 && mode === 'add') {
      setModal(true);
    }
    setformValues(finalValues);
  };

  const submitWithDuplicateCrewCheck = (finalValues) => {
    const hasDuplicates = hasDuplicateCrewLineItems(
      finalValues?.purchaseOrderCrew,
      finalValues?.expenseCategoryId,
      expenseCategoryList,
      defaultCrewData?.uuid
    );

    if (hasDuplicates) {
      if (isTrainingExpenseCategory(finalValues?.expenseCategoryId, expenseCategoryList)) {
        duplicateCrewProceedRef.current = () => {
          duplicateCrewConfirmedRef.current = true;
          continueSubmitAfterDuplicateCheck(finalValues);
        };
        setShowDuplicateCrewModal(true);
        return;
      }
      showAlert('A combination of Crew Code and Expense Line Item already exists in the list', 'error');
      return;
    }

    duplicateCrewConfirmedRef.current = false;
    continueSubmitAfterDuplicateCheck(finalValues);
  };

  const openDuplicate = (id) => {
    window.open(`/po/${id}`);
  };
  const handleDiscard = () => {
    setModal(false);
    setisduplicateloading(false);
    history.push('/');
  }
  const handleSave = () => {
    setSaveModal(false);
    setMailModal(true);
  };
  const handleDraft = (values) => () => {
    if (mode === 'edit') {
      editPurchaseOrder({
        ...values,
        purchaseOrderCrew: values?.purchaseOrderCrew?.map(normalizeJoinedVesselGuids) ?? values?.purchaseOrderCrew
      });
      showAlert('Purchase Order Updated Successfully', 'success');
      history.push(`/po/${poId}`);
      setSaveModal(false);
    } else {
    setSaveModal(false);
    addPurchaseOrder(values);
    }
  };
  const handleMail = () => {
    setisduplicateloading(false);
    if (mailBasicInfo?.to?.length > 0 && mailBasicInfo?.subject?.length > 0) {
        if (mode === 'add') {
      const withMailValuesAdd = {...formValues, mailBasicInfo: [mailBasicInfo] };
    sendPurchaseOrder(withMailValuesAdd);
        } else {
         const withMailValuesEdit = {poId, mailBasicInfo : [mailBasicInfo]};
        sendPOEditData(withMailValuesEdit);
        }
      // }
    setMailModal(false);
    } else {
      if (mailBasicInfo?.to?.length === 0){
      showAlert('Please fill the To field', 'error');
      }else if(mailBasicInfo?.subject?.length === 0){
      showAlert('Please fill the Subject field', 'error');
      }
    }
  };
  const cancelMail = () => {
    if (mode === 'edit') {
      editPurchaseOrder(formValues);
      showAlert('Purchase Order Updated Successfully', 'success');
      history.push(`/po/${poId}`);
      setMailModal(false);
    } else {
    setMailModal(false);
    addPurchaseOrder(formValues);
    }
  };

  if (
    isAddLoading
    || sendPOEditLoading
    || issendPurchaseOrderLoading
    || isEditLoading
    || expenseCategoryLoading
    || isFetchingPo
    || purposeLevelOneLoading
  ) {
    return <Loader message="Loading" />;
  }
  return (
    <>
      <div className="pb-28.5">
        <Formik
          initialValues={dataObj}
          enableReinitialize
          validationSchema={validationSchema}
          validate={(values) => {
            const trainingId = expenseCategoryList?.find(({ label }) => label === 'Training')?.expenseCategoryID;
            let error = {};
            const companySelected = companyList.find(obj => obj.id === values?.companyId);
            if (values?.expenseCategoryId === trainingId && !companySelected?.groupCompanyCode) {
              error.companyId = 'Please select company with shipnet code';
            }
            if (values?.companyId && !companySelected?.sapCompanyCode) {
              error.companyId = 'Please select company with SAP Company Code';
            }
           const vendorSelected = filteredVendorList?.find((v) => v.id === values?.vendorId);
           if (values?.vendorId && vendorSelected?.sapVendorCode === null) {
             error.vendorId = 'Please select vendor with SAP Vendor Code';
           }
            
            // Get vendor code and category for Rank validation (only for Training category with specific vendors)
           const selectedVendorForValidation = filteredVendorList?.find(({ id, value }) => id === values?.vendorId || value === values?.vendorId);
            const vendorCodeForValidation = selectedVendorForValidation?.vendorCode?.toUpperCase() || '';
            const trainingCategoryId = expenseCategoryList?.find(({ label }) => label === 'Training')?.expenseCategoryID;
            const isTrainingCategory = values?.expenseCategoryId === trainingCategoryId;
            const isRankMandatoryVendor = vendorCodeForValidation.includes('MSSG') || vendorCodeForValidation.includes('SEALEARNINGSG');
            const isRankMandatory = isTrainingCategory && isRankMandatoryVendor;
            
            const eqGuid = (a, b) => {
              if (a == null || b == null) return false;
              const sa = String(a).trim().toLowerCase();
              const sb = String(b).trim().toLowerCase();
              return sa === sb;
            };
            values?.purchaseOrderCrew?.map((crewMember, crewIndex) => {

                   const vesselRevisionId = crewMember?.plannedVesselRevisionId;
                     if (vesselRevisionId && vesselList?.length > 0) {
                       const originalCrew = dataObj?.purchaseOrderCrew?.[crewIndex];
                       const vesselUnchanged = mode === 'edit' && originalCrew && (
                         eqGuid(originalCrew?.plannedVesselRevisionId, vesselRevisionId) ||
                         eqGuid(originalCrew?.plannedVesselId, crewMember?.plannedVesselId)
                       );
                       if (!vesselUnchanged) {
                         const vesselSelected = vesselList?.find((v) =>
                           eqGuid(v.value, vesselRevisionId)
                         );
                         if (vesselSelected && !vesselSelected?.sapVesselCompanyCode) {
                           error.purchaseOrderCrew = 'Please select vessel with SAP Vessel Code';
                         }
                       }
                     }

              if(isCrewPage){
                if (values?.purchaseOrderCrew[crewIndex].crewCode) {
                  const missingDateOfBirth = !crewMember?.dateOfBirth;
                  const missingRank = !crewMember?.rankName && !crewMember?.rankId;
                  
                  // DOB is mandatory for all vendors, Rank is mandatory only for Training category with specific vendors (MSSG/SEALEARNINGS)
                  if (missingDateOfBirth && missingRank && isRankMandatory) {
                    error.purchaseOrderCrew = error.purchaseOrderCrew || [];
                    error.purchaseOrderCrew[crewIndex] = error.purchaseOrderCrew[crewIndex] || {};
                    error.purchaseOrderCrew[crewIndex].crewCode = 'Crew Date of Birth and Rank is mandatory';
                  } else if (missingDateOfBirth) {
                    // DOB validation for all vendors
                    error.purchaseOrderCrew = error.purchaseOrderCrew || [];
                    error.purchaseOrderCrew[crewIndex] = error.purchaseOrderCrew[crewIndex] || {};
                    error.purchaseOrderCrew[crewIndex].crewCode = 'Crew Date of Birth is mandatory';
                  } else if (missingRank && isRankMandatory) {
                    // Rank validation only for Training category with specific vendors
                    error.purchaseOrderCrew = error.purchaseOrderCrew || [];
                    error.purchaseOrderCrew[crewIndex] = error.purchaseOrderCrew[crewIndex] || {};
                    error.purchaseOrderCrew[crewIndex].crewCode = 'Crew Rank is mandatory';
                  }
                }}
            });
            if (!isCrewPage && values?.purchaseOrderCrew?.length > 1) {
              const firstVesselId = values?.purchaseOrderCrew?.[0]?.plannedVesselId;
              const hasDifferentVessel = values?.purchaseOrderCrew?.some(
                item => item.plannedVesselId && item.plannedVesselId !== firstVesselId
              );
              if (hasDifferentVessel) {
                error.purchaseOrderCrew = 'Different vessels are not allowed in Vessel POs. All PO Line-items should have the same vessel';
              }
            }
            return error;
          }}
          
          onSubmit={(values) => {
            if (selectedDefaultCrewData && selectedDefaultCrewData.crewCode) {
              const isDuplicate = values.purchaseOrderCrew.some(
                (crew) => crew.crewCode === selectedDefaultCrewData.crewCode
              );
          
              if (isCrewPage && isDuplicate) {
                setPendingValues(values);
                setShowConfirmModal(true);
                return;
              }
            }
            const updatedCrew = values.purchaseOrderCrew.map((crew, index) => {
              const code = getAccountCode(index,values);
              return normalizeJoinedVesselGuids({
                ...crew,
                accountCode: code || '',
                plannedVesselRevisionId: crew.plannedVesselRevisionId || NULL_GUID
              });
            });
            values.pocategory=isCrewPage?0:1
            const finalValues = {
              ...values,
              purchaseOrderCrew: updatedCrew,
            };

            submitWithDuplicateCrewCheck(finalValues);
          }}
        >
          {({ values, errors, touched, setFieldValue, submitCount }) => {
            const prevSubmitCountRef = React.useRef(submitCount);
            const sapPoNumberPosition = values?.sapPoNumberPosition || dataObj?.sapPoNumberPosition || '-';
            const normalizedSapPoNumberPosition = sapPoNumberPosition.toLowerCase().replace(/[^a-z]/g, '');
            const showHeaderSapPoNumber = mode === 'edit' && normalizedSapPoNumberPosition === 'header';
            useEffect(() => {
              const err = errors.purchaseOrderCrew;
              if (submitCount > prevSubmitCountRef.current && typeof err === 'string' && err) {
                showAlert(err, 'error');
              }
              prevSubmitCountRef.current = submitCount;
            }, [errors.purchaseOrderCrew, submitCount]);


            useEffect(() => {
              if (company?.data?.result) {
                const { id } = company?.data?.result || {};
                setFieldValue('companyId', id);
              }
            }, [company]);

            useEffect(() => {
              if (values?.description) {
            setFieldValue('description', values?.description);
              } 
            }, [values?.description]);
            useEffect(() => {
              const ppe = expenseCategoryList?.find(({ label }) => label === 'PPE' || label === 'Vessel PPE')?.expenseCategoryID;
              if (values?.expenseCategoryId === ppe) {
                const temp=orderBy(formatDropdownOptions(currencies?.data, 'code', 'id'), 'code')
                setCurrencyList(temp?.filter((item) => item?.label === 'INR' || item?.label === 'USD'));
              } else {
                setCurrencyList(orderBy(formatDropdownOptions(currencies?.data, 'code', 'id'), 'code'));
              }
            }, [values?.expenseCategoryId]);
            const resetCategoryRelatedFields = () => {
              setFieldValue('companyId', null);
              setFieldValue('vendorId', '');
              setFieldValue('expenseLineItemId', '');
              setFieldValue('budgetCategory', '');
              setFieldValue('currencyId', 1 );
              setFieldValue('description', '');
              setFieldValue('purposeId', '');
              setFieldValue('purposeLevelId', '');
              setAddress('');
              setexpenseitemsData([]);
              setfilteredVendorList([]);
            };

            useEffect(() => {
              if (values?.purposeId) {
                getLevelTwoPurposeData(values?.purposeId);
              }
            }, [values?.purposeId]);

            useEffect(() => {
              const decodedToken = jwt_decode(localStorage.getItem('access_token'));
              setmailBasicInfo({ ...mailBasicInfo, cc: [decodedToken?.email] });
            }, []);
            useEffect(() => {
              if (values?.vendorId) {
                const vendor = filteredVendorList?.find(({ id }) => id === values?.vendorId);
                if (vendor === undefined) {
                const vendorAdd = { id: values?.vendorId,
                  value: values?.vendorId,
                  vendorName: values?.vendorsName,
                  label: buildVendorDropdownLabel(
                    values?.vendorCode,
                    values?.vendorsName,
                    values?.sapVendorCode
                  ),
                  searchLabel: buildVendorSearchLabel(
                    values?.vendorCode,
                    values?.vendorsName,
                    values?.sapVendorCode
                  ),
                  vendorCode: values?.vendorCode,
                  sapVendorCode: values?.sapVendorCode,
                  address: values?.address
                };
                // adding vendorAdd object to filteredVendorList
                const newVendorList = [...filteredVendorList, vendorAdd];
                setfilteredVendorList(newVendorList);
              }
                const address = vendor?.vendorAddress
                if (address === null) {
                setAddress('');
                } else {
                  setAddress(address);
              }
            }
            }, [values?.vendorId, dataObj, filteredVendorList, values?.purchaseOrderCrew]);
            useEffect(() => {
              if (values?.vendorId) {
                getvendorExpensiveData(values);
              }
              if (oldVendorId !== values?.vendorId) {
                  setFieldValue('companyId', null);
                  setFieldValue('expenseLineItemId', '');
                  setFieldValue('budgetCategory', '');
                  setFieldValue('currencyId', 1);
                  setFieldValue('description', '');
                  setFieldValue('purposeId', '');
                  setFieldValue('purposeLevelId', '');
                  setFieldValue('purchaseOrderCrew', [{
                    crewId: '',
                    expenseLineItemId: '',
                    plannedVesselId: '',
                    amount: '',
                    crewCode: '',
                    categoryDetails: '',
                    ppeCategoryDetails: '',
                    ppeDeliveryRemarks: ''
                  }]);
              }
            }, [values?.vendorId]);
            useEffect(() => {
              if (values?.companyId) {
                      getVesselData(values?.companyId);
              }
            }, [values?.companyId]);

            useEffect(async () => {
              if (formValues) {
                let invalidCourceData;
                // check formvalues?.expenseCategoryId is Training expense categoryId
                const trainingId = expenseCategoryList?.find(({ label }) => label === 'Training')?.expenseCategoryID;
                if (formValues?.expenseCategoryId === trainingId) {
                const expenseLineItemId = formValues?.purchaseOrderCrew?.map((crew) => crew?.expenseLineItemId) ?? [];
                const payload = {
                    expenseCategoryId: formValues.expenseCategoryId,
                    vendorId: formValues.vendorId,
                    expenseLineItemId
                };                
                invalidCourceData = await axios.post(apiurl?.validateCourseCode, payload);
              }
                if (
                  (!modal && (isDraft || mode === 'edit')) ||
                  (modal && formValues && 'isBulkOrder' in formValues) ||
                  formValues?.purchaseOrderCrew?.length < 2
                ) {
                  if (duplicate?.data.isDuplicateExists) {
                    setduplicateData(duplicate.data.poInfo);
                    setSaveModal(true);
                    } else {
                    createReqFormat(invalidCourceData);
                  }
                }
              }
            }, [formValues]);
            useEffect(() => {
              if (values?.expenseCategoryId) {
                setCompanyId('')
                const fetchData = async () => {
                  getCompanyByCategory();
                  if(mode === 'add'){
                  try {
                    const crewData = await getDefaultCrew(0);
                    setDefaultCrewData(crewData.data);
                    setSelectedDefaultCrewData(crewData.data)
                  } catch (error) {
                    console.error('Error fetching crew data:', error);
                  }
                }
                else if(mode === 'edit'){
                  setCompanyId(values.companyId)
                  const crewData = await getDefaultCrew(0);
                  setDefaultCrewData(crewData.data);
                  setSelectedDefaultCrewData(crewData.data)
                  setSavedAccountCode(dataObj?.purchaseOrderCrew)
                }
                };
                fetchData()
              }
              
              const airfareId = expenseCategoryList?.find(({ label }) => label === 'Airfare')?.expenseCategoryID;
              if (values?.expenseCategoryId === airfareId) {
                  setairfareOpen(0);
              } else {
                setairfareOpen(null);
              }
              if (values?.expenseCategoryId) {
                if (!initialDataLoaded) {
                  resetCategoryRelatedFields();
                }
                const expenseItems = expenseItemList?.filter(({ expenseCategoryID }) => expenseCategoryID === values?.expenseCategoryId);
                getvendorCategoryData(values?.expenseCategoryId);
                if (OldExpenseCategoryId === values?.expenseCategoryId) {
                  if (filterAndFillExpItm(expenseItems)) {
                    setexpenseitemsData((prev) => {
                      return [{ ...dataObj, label: dataObj?.purchaseOrderCrew?.expenseLineItem, value: dataObj.purchaseOrderCrew.expenseLineItemId }, ...prev];
                    });
                  }
                }
                setinitialDataLoaded(true);
                if (OldExpenseCategoryId !== values?.expenseCategoryId) {
                  resetCategoryRelatedFields();
                  setFieldValue('dateOfService', []);
                  setFieldValue('purchaseOrderCrew', [{
                    crewId: '',
                    expenseLineItemId: '',
                    plannedVesselId: '',
                    amount: '',
                    crewCode: '',
                    categoryDetails: '',
                    ppeCategoryDetails: '',
                    ppeDeliveryRemarks: ''
                  }]);
                }
              }
            }, [values?.expenseCategoryId]);

            useEffect(() => {
              if (values?.CheckIn) {
                if (!checkOutDataLoaded) {
                  setFieldValue('CheckOut', '');
                }
                setcheckOutDataLoaded(false);
              }
            }, [values?.CheckIn]);

           const OnchangedCompanyValue = async(id,values) => {
            try {
              const trainingId = expenseCategoryList?.find(({ label }) => label === 'Training')?.expenseCategoryID;	
              setCompanyId(id)
              if(values)
                {
                 values.purchaseOrderCrew.forEach((element,index) => {
                       {
                       setFieldValue(`purchaseOrderCrew[${index}].age`, null);
                       setFieldValue(`purchaseOrderCrew[${index}].firstName`, null);
                       setFieldValue(`purchaseOrderCrew[${index}].lastName`, null);
                       setFieldValue(`purchaseOrderCrew[${index}].gender`, null);
                       setFieldValue(`purchaseOrderCrew[${index}].dateOfBirth`, null);
                       setFieldValue(`purchaseOrderCrew[${index}].rankName`, null);
                       setFieldValue(`purchaseOrderCrew[${index}].crewCode`, null);
                       setFieldValue(`purchaseOrderCrew[${index}].crewId`, null);
                     
                     }
                 });
                }
            } catch (error) {
              console.error('Error fetching crew data:', error);
            }             
              setFieldValue(`purchaseOrderCrew[0].ppeCategoryDetails`, []);
              setFieldValue(`purchaseOrderCrew[0].amount`, '');
              setFieldValue(`purchaseOrderCrew[0].plannedVesselId`, '');

            }
            return (
              <>
              <Form className="grow" id="my-form" >
                {values?.poNumber ? (
                  <div className=" text-base mb-4 mt-6">
                    {values?.poNumber}
                    <span className="pl-2">
                    {values?.poStatus && <Chip style={{backgroundColor: values?.dueDate >= 180 ? '#f68681' : '#f8e3b4', borderRadius: 0 }} size="small" label={values?.poStatus} />}
                    </span>
                  </div>
                ) : <div className=" text-xl mb-4 capitalize font-bold mt-6">Create new PO</div>}
              <div
                onClick={() => { return setopenHeader(!openHeader); }}
                className="flex flex-row place-content-between mb-4  mt-4 bg-secondary-500 p-1 px-2.5 rounded-md  cursor-pointer"
              >
                <div className="text-base font-muli text-white-light  font-bold">Expense Details</div>
                  <img src={polygon} alt="polygon" className={`${!openHeader ? 'transform -rotate-90' : ''} w-6`} />
              </div>
              {openHeader && (
                <div className="grid grid-cols-3 gap-6 p-1 newDataError">
                  <Field
                    name="expenseCategoryId"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={expenseCategoryList}
                    rounded
                    dataObj = {dataObj}
                    requiredField
                    isDisabled={(disableHeader || dataObj?.poStatus ? dataObj.poStatus.toLowerCase() !== 'draft' : false) || (SYSTEM_GENERATED_CATEGORY_LIST.includes(dataObj?.expenseCategoryName))}
                    id="select1"
                    type="text"
                    placeholder=""
                    label="Expense Category"
                  />
                  <Field
                    name="vendorId"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={filteredVendorList}
                    rounded
                    requiredField
                    isDisabled={disableHeader || dataObj?.poStatus? dataObj?.poStatus.toLowerCase() !== 'draft' : false}
                    id="select1"
                    type="text"
                    placeholder=""
                    label="Vendor"
                  />
                  <Field
                  name="vendorAddress"
                  component={InputFieldComponent}
                  className="w-full"
                  id="number"
                  size="medium"
                  variant="text"
                  rounded
                  disabled
                  value={vendorAddress}
                  label="Vendor Address"
                />
                  <Field
                    name="companyId"
                    component={DropdownFieldComponent}
                    setChangedValue={(id)=>OnchangedCompanyValue(id,values)}
                    className="w-full"
                    options={companyList}
                    rounded
                    isDisabled={disableHeader || dataObj?.poStatus? dataObj?.poStatus.toLowerCase() !== 'draft' : false}
                    requiredField
                    id="select1"
                    type="text"
                    placeholder=""
                    label="Company"
                  />
                  <Field
                    name="budgetCategory"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={budgetCategoryList}
                    rounded
                    isDisabled={disableHeader}
                    id="select1"
                    type="text"
                    placeholder=""
                    label="Budget Category"
                    isClearable
                  />
                  {showHeaderSapPoNumber && (
                    <Field
                      name="sapPoNumber"
                      component={InputFieldComponent}
                      className="w-full"
                      id="sapPoNumber"
                      size="medium"
                      variant="text"
                      rounded
                      disabled
                      value={values?.sapPoNumber || '-'}
                      label="SAP PO Number"
                    />
                  )}
                  <Field
                    name="currencyId"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={currencyList}
                    rounded
                    requiredField
                    isDisabled={disableHeader || dataObj?.poStatus? dataObj?.poStatus.toLowerCase() !== 'draft' : false}
                    id="select1"
                    type="number"
                    placeholder=""
                    label="Currency"
                  />
                  <Field
                    name="purposeId"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={purposeLevelOneList}
                    rounded
                    isDisabled={disableHeader}
                    setFieldsNull={['purposeLevelId']}
                    id="select1"
                    type="text"
                    placeholder=""
                    label="Level 1 Purpose"
                    isClearable
                  />
                  <Field
                    name="purposeLevelId"
                    component={DropdownFieldComponent}
                    className="w-full"
                    options={purposeLevelTwoList}
                    rounded
                    isDisabled={disableHeader}
                    id="select1"
                    type="text"
                    placeholder=""
                    label="Level 2 Purpose"
                    isClearable
                  />

                </div>
              )}
                <CrewForm {...{ values, dataObj, mode, errors, touched, setFieldValue, expenseitemsData, vesselList, expenseCategoryList,restoredPpeCategoryDetails,setRestoredPpeCategoryDetails,defaultCrewData, expenseItemList,companyId,setcreatedAccountCode,selectedDefaultCrewData,savedaccountCode}}setDefaultCrewData={setDefaultCrewData} setSavedAccountCode={setSavedAccountCode} />

                <DateofService {...{ values }} errors={errors?.dateOfService} touched={touched?.dateOfService} />
                <div className=" p-1 newDataError">
                <Field
                  name="description"
                  component={InputFieldComponent}
                  className="w-full pt-3 text-base mb-4 "
                  id="number"
                  type="text"
                  rounded
                  disabled={disableHeader}
                  autoComplete="off"
                  label="Description"
                  multiline
                />
                </div>
              </Form>
              </>
            );
          }}
        </Formik>
      </div>
      {modal && (
        <ConfirmCreate
          {...{
            modal,
            setModal,
            handleBulkOrder,
            handleCreate
          }}
        />
      )}
                    {saveModal && (
                <DuplicateSave
                  modal={saveModal}
                  setModal={setSaveModal}
                  openDuplicate={openDuplicate}
                  handleSave={handleSave}
                  handleDraft={handleDraft(formValues? formValues : editPoValues)}
                  handleDiscard={handleDiscard}
                  duplicateData={duplicateData}
                  setisduplicateloading={setisduplicateloading}
                  poId={poId}
                  isPPE={
                    ['PPE', 'Vessel PPE'].some(label =>
                      expenseCategoryList?.find(item => item.label === label)?.value === editPoValues?.expenseCategoryId ||
                      expenseCategoryList?.find(item => item.label === label)?.value === editPoValues?.expenseCategoryId
                    )
                  }                />
              )}
      {mailModal && (
        <MailModal
          {...{
            mailModal,
            setMailModal,
            handleMail,
            cancelMail,
            currencyList,
            vesselList,
            isCrewPage,
            mailBasicInfo,
            setmailBasicInfo,
            formValues: formValues || editPoValues,
            filteredVendorList: mailVendorList
          }}
        />
      )}
      {showDuplicateCrewModal && (
        <ConfirmDuplicateCrewLineItem
          modal={showDuplicateCrewModal}
          setModal={setShowDuplicateCrewModal}
          onConfirm={() => {
            duplicateCrewProceedRef.current?.();
            duplicateCrewProceedRef.current = null;
          }}
          onCancel={() => {
            duplicateCrewProceedRef.current = null;
            duplicateCrewConfirmedRef.current = false;
          }}
        />
      )}
      {showConfirmModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg shadow-lg p-6 w-[400px]">
      <div className="uppercase pb-4 text-center text-lg font-bold">Common Crew Confirmation</div>
      <label className="mb-6 text-base">
        You have selected <strong>Common Crew</strong>. Do you want to proceed?
      </label>
      <div className="flex justify-end gap-4">
      </div>
      <div className="flex flex-row float-right mt-4">
                            <div className="table-cell p-2">
                                <Button
                                    type="button"
                                    size="medium"
                                    variant="outlined"
                                    rounded
                                    className="w-18 text-xs h-10"
                                    onClick={() => {
                                      setShowConfirmModal(false);
                                      setPendingValues(null);
                                    }}                                >
                                    Cancel
                                </Button>
                            </div>
                            <div className="table-cell p-2">
                                <Button
                                    type="button"
                                    size="medium"
                                    variant="primary"
                                    rounded
                                    className="w-20 text-xs h-10"
                                    onClick={() => {
                                      if (pendingValues) {
                                        const updatedCrew = pendingValues.purchaseOrderCrew.map((crew, index) => {
                                          const code = getAccountCode(index, pendingValues);
                                          return normalizeJoinedVesselGuids({
                                            ...crew,
                                            accountCode: code || '',
                                            plannedVesselRevisionId: crew.plannedVesselRevisionId || NULL_GUID
                                          });
                                        });
                          
                                        const finalValues = {
                                          ...pendingValues,
                                          purchaseOrderCrew: updatedCrew,
                                        };

                                        setShowConfirmModal(false);
                                        setPendingValues(null);
                                        submitWithDuplicateCrewCheck(finalValues);
                                      }
                                    }}
                                >
                                    Proceed
                                </Button>
                            </div>
                        </div>   
    </div>
  </div>
)}

    </>
  );
};

export default withMasterData(POForm);
